module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/automated-food-dispenser/"},"excerpt":"When I’m relaxing, I often think about relaxing. One day, my mind wandered and I designed an automated food dispenser using a  Raspberry Pi…","timeToRead":1,"frontmatter":{"title":"An Automated Food Dispenser","tags":["css","django","javascript","python"]}}}]}},"pathContext":{"tag":"javascript"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/tags-javascript.json
// module id = 765
// module chunks = 67335324583948